'use client';

import type { PackResponseDtoNft, UnwrappedPackDtoRarity } from '~/lib/api';
import { usePacksControllerGetPackById } from '~/lib/api';
import { PackActions } from '~/module/pack/pack-actions';
import { StickerSheetContent } from '../sticker-sheet-content';

export interface UnwrappedPackCardProps {
  id: string;
  label: number | string;
  rarity: UnwrappedPackDtoRarity;
  imageSrc: string | null;
  imagePosition?: 'contain' | 'cover';
  title: string;
  brandName?: string | null;
  className?: string;
  nft?: PackResponseDtoNft;
  stakedTill?: string | null;
}

export function UnwrappedPackCardSheetContent({
  brandName,
  rarity,
  title,
  id,
}: Pick<UnwrappedPackCardProps, 'brandName' | 'id' | 'rarity' | 'title'>) {
  const { data: pack, refetch } = usePacksControllerGetPackById(id);
  const isMinted = pack?.data.nft?.nftMintStatus === 'DONE';

  return (
    <StickerSheetContent
      bottomContent={
        <div className="p-4">
          <PackActions packId={id} refetchPack={() => void refetch()} />
        </div>
      }
      brandName={brandName ?? ''}
      numberInCollection={pack?.data.unwrapped?.numberInCollection}
      rarity={rarity}
      showMintIndicator={isMinted}
      stickers={pack?.data.unwrapped?.stickers ?? []}
      title={title}
    />
  );
}
